export const VoteParamKey = {
	voteText: 'imolVoteText',
	likeText: 'imolVoteLike',
	dislikeText: 'imolVoteDislike',
	currentVote: 'imolVote',
	timeLimit: 'imolTimeLimitVote',
	voteCloseDate: 'imolDateCloseVote',
};
